import { Component, OnInit } from '@angular/core';
import { AuthService, AssortmentService } from 'gung-standard';
import { Router } from '@angular/router';
import { first } from 'rxjs';

@Component({
    selector: 'cult-home',
    templateUrl: './cult-home.component.html',
    styleUrls: ['./cult-home.component.scss'],
    standalone: false
})
export class CultHomeComponent implements OnInit {
  isSales = false;
  constructor(private router: Router, private authService: AuthService, private assortmentService: AssortmentService) {}

  ngOnInit() {
    this.authService.getCurrentUser().pipe(first()).subscribe(user => {
      if (user.activeGroups.B2B_CULT) {
        this.router.navigateByUrl('/page/Startsida B2B Cult Design');
      } else if (user.activeGroups.B2B_HEDLUND) {
        this.router.navigateByUrl('/page/Startsida B2B Hedlundgruppen');
      } else if (user.roles.includes('SALES')) {
        this.router.navigateByUrl('/categories');
      } else {
        this.navigateToFirstSubAssortmentOrDefault();
      }
    });
  }

  private navigateToFirstSubAssortmentOrDefault(): void {
    this.authService
      .getIsAuthenticated()
      .pipe(first())
      .subscribe(auth => {
        if (auth) {
          this.assortmentService
            .getUserAssortment()
            .pipe(first())
            .subscribe(assortment => {
              const subAssortments = assortment.children
                .filter(a => a.id && a.id.length > 0 && a.id[0] === 's')
                .map(a => {
                  return { route: '/categories/' + a.id, heading: a.name };
                });

              if (subAssortments && subAssortments.length !== 0) {
                this.router.navigateByUrl(subAssortments[0].route);
              } else {
                this.router.navigateByUrl('/products');
              }
            });
        }
      });
  }
}
